module.exports = __webpack_public_path__ + "img/bg-pattern2.c212ce31.png";